import { useEffect, useState } from "react"
import LoginComponent from "./LoginComponent";
import PasswordComponent from "./PasswordComponent";
import { Col, Row } from "react-bootstrap";
import { BsChevronLeft } from "react-icons/bs";
import RegisterComponent from "./basic_register/RegisterComponent";
import { useParams } from "react-router-dom";


/**
 * ActionSide
 * 
 * Home page action side where all actions are. Like login,
 * register, reset password, etc.
 * 
 * @param {string} defaultView - To change initial view
 * @param {Object} qrData - (optional) API return data from qr info
 * @param {Function} - Callback function to start promo video
 * @returns 
 */
const ActionsSide = ({defaultView, qrData, showInfoVideo}) => {

    const { token } = useParams(); // Mail token of later upload Jahresabrechnung
    const [view, setView] = useState(defaultView); // view

    // if token is present change view to register
    useEffect(() => {
        if (token) setView("register");
    }, [token])

    // Handler for back button
    const backBtnHandler = (e) => {
        e.preventDefault();
        if (view === "password" || view === "register") return setView("login");
    }

    // GUI
    return (
        <div className="actions-section">
            {view !== "login" &&
                <Row className="mt-3">
                    <Col xs="12" className="mb-5">
                        <a onClick={e => backBtnHandler(e)} href="/zurück" className="link-energo text-light">
                            <BsChevronLeft size={40} /> Zurück
                        </a>
                    </Col>
                </Row>
            }

            {
                view === "login" ?
                    <LoginComponent changeView={setView} qrData={qrData} showInfoVideo={showInfoVideo} /> : 

                view === "password" ? 
                    <PasswordComponent /> :

                view === "register" ?
                    <RegisterComponent qrData={qrData} setView={setView} missingUploadToken={token} /> :
                
                null
            }
        </div>
    )
}
export default ActionsSide;